const CareReminderRouter = [
  {
      path: "list-care_reminder",
      name: "list",
      component: () => import("@/views/admin/care_reminder"),
      default: true,
      meta: {
          model: "care_reminder",
          // requiresAuth: true,
      },
  },
  {
      path: "list-care_reminder/add",
      name: "add",
      component: () => import("@/views/admin/care_reminder/function"),
      default: true,
      meta: {
          model: "care_reminder",
          // requiresAuth: true,
      },
  },
  {
      path: "list-care_reminder/edit/:id",
      name: "edit",
      component: () => import("@/views/admin/care_reminder/function"),
      default: true,
      meta: {
          model: "care_reminder",
          // requiresAuth: true,
      },
  },
];
export default CareReminderRouter;